import React from 'react'

import { withStyles, Dialog } from '@material-ui/core';
import AppLogoLoading from '../../../sc-logo';

const styles = () => ({
    paper: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        overflow: 'hidden'
    },
    logo: {
        width: '250px',
        margin: '10px'
    }
});

const LoadingDialog = (props) => {
    const { classes } = props
    return <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
        open={true}
        PaperProps={{
            classes: {
                root: classes.paper
            }
        }}
    >
        <AppLogoLoading />
    </Dialog>
}


export default (withStyles(styles)(LoadingDialog));